import React, { useState } from "react";

import {
    Settings as SettingsIcon,
    Save
} from "lucide-react";


const Settings = () => {

    const [form, setForm] = useState({

        companyName:
            "Bhimashankar Agro Coldchain & Processing Producer Pvt. Ltd.",

        totalCapacity:
            "6000",

        currency:
            "INR",

        unit:
            "KG / Tons"

    });


    const change = e => {

        setForm({
            ...form,
            [e.target.name]:
                e.target.value
        });

    };


    const save = e => {

        e.preventDefault();

        alert(
            "Settings saved locally."
        );

    };


    return (
        <div className="page-container">

            <div className="page-header">

                <div>

                    <h2>
                        Settings
                    </h2>

                    <p>
                        ERP configuration
                    </p>

                </div>

            </div>


            <form onSubmit={save}>

                <div className="content-card">

                    <div className="settings-title">

                        <SettingsIcon />

                        <div>
                            <h3>
                                General Settings
                            </h3>

                            <p>
                                Basic cold storage information
                            </p>
                        </div>

                    </div>


                    <div className="form-grid">

                        <div className="form-group">

                            <label>
                                Company Name
                            </label>

                            <input
                                name="companyName"
                                value={
                                    form.companyName
                                }
                                onChange={change}
                            />

                        </div>


                        <div className="form-group">

                            <label>
                                Total Capacity (Tons)
                            </label>

                            <input
                                type="number"
                                name="totalCapacity"
                                value={
                                    form.totalCapacity
                                }
                                onChange={change}
                            />

                        </div>


                        <div className="form-group">

                            <label>
                                Currency
                            </label>

                            <select
                                name="currency"
                                value={
                                    form.currency
                                }
                                onChange={change}
                            >
                                <option value="INR">
                                    INR
                                </option>
                                <option value="USD">
                                    USD
                                </option>
                            </select>

                        </div>


                        <div className="form-group">

                            <label>
                                Weight Unit
                            </label>

                            <input
                                name="unit"
                                value={
                                    form.unit
                                }
                                onChange={change}
                            />

                        </div>

                    </div>

                </div>


                <div className="form-actions">

                    <button
                        type="submit"
                        className="primary-button"
                    >
                        <Save size={17} />
                        Save Settings
                    </button>

                </div>

            </form>

        </div>
    );
};


export default Settings;